import { postionsConstants } from '../../constants/position';
import { reportConstants } from '../../constants/reports';

const transactionsListMap = [
	{ label: reportConstants.REPORT_TRANSACTION_ID, key: reportConstants.COLUMN_TRANSACTION_ID },
	{ label: reportConstants.REPORT_SESSION_ID, key: reportConstants.COLUMN_SESSION_ID },
	{ label: reportConstants.REPORT_PLAYER_ID, key: reportConstants.COLUMN_PLAYER_ID },
	{ label: reportConstants.REPORT_EXT_PLAYER_ID, key: reportConstants.COLUMN_EXT_PLAYER_ID },
	{ label: reportConstants.REPORT_PARTNER, key: reportConstants.COLUMN_PARTNER },
	{ label: reportConstants.REPORT_SKIN, key: reportConstants.COLUMN_SKIN },
	{ label: reportConstants.REPORT_TP_TRX_ID, key: reportConstants.COLUMN_THIRDPARTY_TRX_ID },
	{ label: reportConstants.REPORT_ROUND_ID, key: reportConstants.COLUMN_ROUND_ID },
	{ label: reportConstants.REPORT_PROVIDER, key: reportConstants.COLUMN_PROVIDER },
	{ label: reportConstants.REPORT_STATUS, key: reportConstants.COLUMN_STATUS_NAME, position: postionsConstants.CENTAR },
	{ label: reportConstants.REPORT_GAME, key: reportConstants.COLUMN_GAME_ID },
	{ label: reportConstants.REPORT_DEVICE, key: reportConstants.COLUMN_DEVICE, position: postionsConstants.CENTAR },
	{ label: reportConstants.REPORT_CURRENCY, key: reportConstants.COLUMN_CURRENCY },
	{ label: reportConstants.REPORT_AMOUNT, key: reportConstants.COLUMN_AMOUNT, position: postionsConstants.RIGHT },
	{
		label: reportConstants.REPORT_ORIGINAL_AMOUNT,
		key: reportConstants.COLUMN_ORIG_AMOUNT,
		position: postionsConstants.RIGHT,
	},
	{ label: reportConstants.REPORT_BALANCE, key: reportConstants.COLUMN_BALANCE, position: postionsConstants.RIGHT },
	{ label: reportConstants.REPORT_TYPE, key: reportConstants.COLUMN_TYPE_NAME },
	{ label: reportConstants.REPORT_SESSION_TYPE, key: reportConstants.COLUMN_WALLET },
	{ label: reportConstants.REPORT_CREATED, key: reportConstants.COLUMN_CREATETIME },
	{ label: reportConstants.REPORT_FINISHED, key: reportConstants.COLUMN_FINISHTIME },
	{ label: reportConstants.REPORT_AAMS_TICKET_ID, key: reportConstants.COLUMN_AAMS_TICKET_ID },
	{ label: reportConstants.REPORT_HAND_DETAILS, key: reportConstants.COLUMN_HAND_DETAILS },
];

const columnFormatter = {
	transaction_id: 'value',
	session_id: 'value',
	player_id: 'value',
	external_player_id: 'value',
	partner: 'value',
	skin: 'value',
	thirdparty_trx_id: 'value',
	round_id: 'value',
	provider: 'value',
	status_name: 'value',
	currency: 'value',
	amount: 'cents',
	orig_amount: 'cents',
	balance: 'cents',
	type_name: 'value',
	wallet: 'value',
	createtime: 'value',
	finishtime: 'value',
	aams_ticket_id: 'value',
	context: 'value',
};

export { transactionsListMap, columnFormatter };
